import { useState } from "react";
import { ArrowUpRight, Leaf } from "lucide-react";
import SeanceForm from "./SeanceForm";
import { MaskedLine, Reveal } from "./motion";

const INCLUSIONS = [
    "Séance photo extérieure pour 2 personnes.",
    "Environ 1 heure de séance.",
    "10 à 15 photos retouchées.",
    "Une belle impression 14 × 11 pouces avec cadre incluse.",
    "Et quelques photos supplémentaires en cadeau.",
];

export default function PromoAutomne() {
    const [formOpen, setFormOpen] = useState(false);

    return (
        <section
            id="special-automne"
            data-testid="section-promo-automne"
            className="relative overflow-hidden border-t border-[#D4AF37]/15 py-24 sm:py-32"
        >
            <div className="absolute inset-0">
                <img
                    src="/photo-animaux.jpg"
                    alt=""
                    aria-hidden="true"
                    className="h-full w-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-[#050505]/85" />
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(5,5,5,0.55),rgba(5,5,5,0.2)_70%)]" />
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.10),transparent_60%)]" />
                <div className="absolute inset-0 bg-[linear-gradient(to_bottom,#050505,transparent_20%,transparent_80%,#050505)]" />
            </div>

            <div className="relative z-10 mx-auto max-w-3xl px-5 text-center sm:px-10">
                <Reveal>
                    <p className="font-mono-lux mb-8 flex items-center justify-center gap-4 text-[11px] tracking-[0.4em] text-[#D4AF37]">
                        <span className="inline-block h-px w-10 bg-[#D4AF37]/60" />
                        L'AUTOMNE EN IMAGES
                        <span className="inline-block h-px w-10 bg-[#D4AF37]/60" />
                    </p>
                </Reveal>
                <h2
                    data-testid="promo-automne-title"
                    className="font-display text-3xl font-medium tracking-tight text-white sm:text-4xl lg:text-5xl"
                >
                    <MaskedLine delay={0.1}>
                        <Leaf
                            className="mr-3 inline-block h-8 w-8 -translate-y-1 text-[#D4AF37] sm:h-10 sm:w-10"
                            strokeWidth={1.2}
                        />
                        SPÉCIAL{" "}
                        <span className="text-gold-grad italic">
                            D'AUTOMNE
                        </span>
                    </MaskedLine>
                </h2>

                <Reveal delay={0.25}>
                    <p className="mx-auto mt-7 max-w-xl text-base font-light leading-relaxed text-[#E2E2E2]/90 sm:text-lg">
                        Profitez de la magnifique lumière et des couleurs de
                        l'automne pour créer de beaux souvenirs en plein air.
                    </p>
                </Reveal>

                <Reveal delay={0.35}>
                    <ul className="mx-auto mt-9 flex max-w-xl flex-col items-center gap-3.5">
                        {INCLUSIONS.map((item) => (
                            <li
                                key={item}
                                className="flex items-center gap-3 text-sm font-light text-[#E2E2E2]/90 sm:text-base"
                            >
                                <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-[#D4AF37]" />
                                {item}
                            </li>
                        ))}
                    </ul>
                </Reveal>

                <Reveal delay={0.45}>
                    <div className="mt-10">
                        <span
                            data-testid="promo-automne-price"
                            className="font-display text-gold-grad text-6xl font-semibold leading-none [text-shadow:0_0_40px_rgba(212,175,55,0.35)] sm:text-7xl"
                        >
                            140 $
                        </span>
                    </div>
                    <p className="mx-auto mt-7 max-w-lg text-sm font-light italic leading-relaxed text-[#E2E2E2]/80 sm:text-base">
                        Une séance simple, chaleureuse et naturelle, réalisée
                        dans un magnifique décor automnal choisi ensemble.
                    </p>
                    <p className="font-mono-lux mt-5 text-[10px] tracking-[0.3em] text-[#D4AF37]">
                        PLACES LIMITÉES PENDANT LA SAISON DES COULEURS
                    </p>
                </Reveal>

                <Reveal delay={0.55}>
                    <button
                        type="button"
                        data-testid="promo-automne-button"
                        onClick={() => setFormOpen(true)}
                        className="group mt-11 inline-flex items-center gap-3 border border-[#D4AF37] bg-gradient-to-r from-[#9A7B38] via-[#D4AF37] to-[#9A7B38] px-7 py-4 font-mono-lux text-[10px] tracking-[0.22em] text-[#050505] transition-all duration-500 hover:shadow-[0_0_45px_rgba(212,175,55,0.4)] sm:gap-4 sm:px-10 sm:py-5 sm:text-xs sm:tracking-[0.3em]"
                    >
                        RÉSERVER MON SPÉCIAL D'AUTOMNE
                        <ArrowUpRight
                            size={16}
                            strokeWidth={1.6}
                            className="transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                        />
                    </button>
                </Reveal>
            </div>
            <SeanceForm open={formOpen} onClose={() => setFormOpen(false)} />
        </section>
    );
}
